export default "__VITE_ASSET__BGS5FKXo__"